import React from 'react';
import Hero from '../components/Hero';
import Expertise from '../components/Expertise';
import WhyUs from '../components/WhyUs';

const Home = () => {
  return (
    <>
      <Hero />
      <Expertise />
      <WhyUs />
    </>
  );
};

export default Home;